var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0624 2.54784L12.1539 2.54541L12.2428 2.54776C12.2865 2.55027 12.3302 2.5548 12.3738 2.56141L12.4051 2.56882C12.5712 2.59549 12.7362 2.65481 12.8935 2.74798L12.9943 2.81318L22.8519 9.74474L32.7031 2.8197C33.6126 2.18047 34.8447 2.75501 34.9864 3.80942L35 4.01257V24.6842C35 25.0911 34.8301 25.4762 34.5369 25.75L34.3804 25.8771L23.6874 33.3941C23.1685 33.7589 22.5444 33.7283 22.078 33.439L12.1531 26.4569L2.29673 33.3875C1.38739 34.0268 0.155282 33.4523 0.013473 32.3977L0 32.1948V11.523C0 11.1161 0.169844 10.731 0.46295 10.4573L0.619573 10.3302L11.3126 2.81318C11.437 2.72571 11.5675 2.66097 11.7004 2.61707L11.9385 2.56262L12.0624 2.54784ZM32.0837 6.82L24.307 12.2869V29.3938L32.0837 23.9269V6.82ZM10.693 6.81348L2.91628 12.2804V29.3872L10.693 23.9203V6.81348ZM13.6139 6.81348V23.9203L21.3907 29.3872V12.2804L13.6139 6.81348Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts3);
export default __webpack_public_path__ + "static/media/contacts-3.c6329642788efd70584e6623858e424a.svg";
export { ForwardRef as ReactComponent };